// packages/components/src/homepage/hero/PillStat.tsx
import React from 'react';
import clsx from 'clsx';
import { Bolt, Globe, Share2, RefreshCcw, ShieldCheck } from 'lucide-react';

export type PillAccent = 'violet' | 'cyan' | 'blue' | 'emerald' | 'slate';

const map: Record<PillAccent, { ring: string; bg: string; text: string }> = {
  violet:  { ring: 'ring-violet-500',  bg: 'from-violet-50 to-violet-100',   text: 'text-violet-900'  },
  cyan:    { ring: 'ring-cyan-500',    bg: 'from-cyan-50 to-cyan-100',       text: 'text-cyan-900'    },
  blue:    { ring: 'ring-blue-500',    bg: 'from-blue-50 to-blue-100',       text: 'text-blue-900'    },
  emerald: { ring: 'ring-emerald-500', bg: 'from-emerald-50 to-emerald-100', text: 'text-emerald-900' },
  slate:   { ring: 'ring-slate-400',   bg: 'from-slate-50 to-slate-100',     text: 'text-slate-900'   },
};

const iconMap: Record<string, React.ReactNode> = {
  bolt: <Bolt className="h-4 w-4" />,
  globe: <Globe className="h-4 w-4" />,
  share: <Share2 className="h-4 w-4" />,
  refresh: <RefreshCcw className="h-4 w-4" />,
  shield: <ShieldCheck className="h-4 w-4" />,
};

export const PillStat: React.FC<{ text: string; accent?: PillAccent; icon?: 'bolt'|'globe'|'share'|'refresh'|'shield'; className?: string; }> = ({
  text, accent = 'slate', icon, className,
}) => {
  const s = map[accent];
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 h-9 px-3 rounded-xl border-2 border-black',
        'bg-gradient-to-b shadow-[0_1px_0_#00000010] ring-1',
        s.bg, s.ring, s.text,
        'text-sm font-bold whitespace-nowrap select-none',
        className
      )}
    >
      {icon ? <span aria-hidden>{iconMap[icon]}</span> : null}
      {text}
    </span>
  );
};

export default PillStat;
